import { render } from "./CostosList.vue?vue&type=template&id=170e99e7&scoped=true"
import script from "./CostosList.vue?vue&type=script&lang=js"
export * from "./CostosList.vue?vue&type=script&lang=js"

import "./CostosList.vue?vue&type=style&index=0&id=170e99e7&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\clogistica_front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-170e99e7"]])

export default __exports__